import React, { useState, useEffect, useRef } from "react";

// Librerias de componentes
import { Toast } from 'primereact/toast';

import ModificarRolModal from "./ModalRoles/ModificarRolModal";
import AgregarRolModal from "./ModalRoles/AgregarRolModal";
import { getRoles } from "../../../API/IT/Roles/RolesRequests";
import Card from "../../../Base/Components/Card/Card";
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Base/Services/Config/ConfigService";
import Icon from "../../../Base/Components/Icon/Icon";
import { Button } from "primereact/button";

// import './RolesStyle.css';

export const RolesScreen = () => {

    const toast = useRef(null);
    const [roles, setRoles] = useState("");
    const [rolEdit, setRolEdit] = useState(null);
    const [loading, setLoading] = useState(true)


    const getInfo = async () => {
        setLoading(true);
        const r = await getRoles();
        setRoles(r);
        setLoading(false)

    }

    useEffect(() => {
        window.document.title = 'PPF • IT Roles';
        getInfo();

    }, []);


    const actionBodyTemplate = (rowData) => {
        return (
            <div className="tableButtons">
                <Button onClick={() => setRolEdit(rowData)} text>
                    <Icon icon={'pi pi-pencil'} /> 
                </Button>
            </div>
        );
    }

    const colums = [
        { field: 'IdRol', header: 'Id', width: 100 },
        { field: 'Rol', header: 'Rol', flex: 1 },
        { field: 'Description', header: 'Description', flex: 1 },
        { field: 'action', header: 'Acciones', width: 200, Format: 'Template', body: actionBodyTemplate }
    ]

    const table = {
        Columns: colums,
        Data: roles,
        loading: loading,
    }

    useEffect(() => {
        setTitlePage('Rol');
    }, []);



    return (
        <div className=" p-fluid px-4" style={{ width: '100%', height: '100%', margin: 'auto' }}>
            <Toast position="bottom-right" ref={toast}></Toast>
            <ModificarRolModal datos={rolEdit} setDatos={setRolEdit} updateRoles={getInfo} />
            <Card
                titulo={<div className="botones">
                    <h3 className="mx-0 my-1 roles__titulo">Roles</h3>
                    <Button icon='pi pi-search' />
                    <AgregarRolModal updateRoles={getInfo} />

                </div>}
                contenido={<div className="p-4" style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />
        </div>
    )
}


export default RolesScreen;
